<template>
  <g>
    <path
      d="M8.4353 21.0002C6.79463 21.0002 5.4646 19.6791 5.4646 18.0494V3.29527C5.4646 3.1323 5.5976 3.00018 5.76167 3.00018H6.98739C7.1193 3.50927 7.58454 3.88543 8.13823 3.88543C8.69193 3.88543 9.15717 3.50927 9.28908 3.00018H10.8493C10.9812 3.50927 11.4465 3.88543 12.0002 3.88543C12.5538 3.88543 13.0191 3.50927 13.151 3.00018H14.7112C14.8431 3.50927 15.3084 3.88543 15.8621 3.88543C16.4158 3.88543 16.881 3.50927 17.0129 3.00018H18.2386C18.4027 3.00018 18.5357 3.1323 18.5357 3.29527V19.5248C18.5357 20.3396 18.5357 21.0002 18.5357 21.0002H8.4353Z"
      fill="white"
    />
    <path
      d="M8.4353 21.0002C6.79463 21.0002 5.4646 19.6791 5.4646 18.0494V3.29527C5.4646 3.1323 5.5976 3.00018 5.76167 3.00018H6.98739C7.1193 3.50927 7.58454 3.88543 8.13823 3.88543C8.69193 3.88543 9.15717 3.50927 9.28908 3.00018H10.8493C10.9812 3.50927 11.4465 3.88543 12.0002 3.88543C12.5538 3.88543 13.0191 3.50927 13.151 3.00018H14.7112C14.8431 3.50927 15.3084 3.88543 15.8621 3.88543C16.4158 3.88543 16.881 3.50927 17.0129 3.00018H18.2386C18.4027 3.00018 18.5357 3.1323 18.5357 3.29527V19.5248C18.5357 20.3396 18.5357 21.0002 18.5357 21.0002H8.4353Z"
      fill="url(#paint0_linear_939_1064)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.4353 20.5002C7.0676 20.5002 5.9646 19.3998 5.9646 18.0494V3.50018H6.65066C6.93596 4.02807 7.4958 4.38543 8.13823 4.38543C8.78067 4.38543 9.34051 4.02807 9.62581 3.50018H10.5126C10.7979 4.02807 11.3577 4.38543 12.0002 4.38543C12.6426 4.38543 13.2024 4.02807 13.4877 3.50018H14.3745C14.6598 4.02807 15.2196 4.38543 15.8621 4.38543C16.5045 4.38543 17.0643 4.02807 17.3496 3.50018H18.0357V20.5002H8.4353ZM4.9646 18.0494C4.9646 19.9584 6.52166 21.5002 8.4353 21.5002H19.0357V3.29527C19.0357 2.85299 18.6757 2.50018 18.2386 2.50018H16.626L16.5289 2.87477C16.4533 3.16667 16.1844 3.38543 15.8621 3.38543C15.5397 3.38543 15.2709 3.16667 15.1952 2.87477L15.0982 2.50018H12.764L12.667 2.87477C12.5913 3.16667 12.3225 3.38543 12.0002 3.38543C11.6778 3.38543 11.409 3.16667 11.3333 2.87477L11.2363 2.50018H8.90213L8.80506 2.87477C8.72943 3.16667 8.46061 3.38543 8.13823 3.38543C7.81585 3.38543 7.54704 3.16667 7.4714 2.87477L7.37434 2.50018H5.76167C5.32463 2.50018 4.9646 2.85299 4.9646 3.29527V18.0494Z"
      fill="#3E7DC0"
    />
    <g filter="url(#filter0_d_939_1064)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00024 8.50018C8.00024 8.22404 8.2241 8.00018 8.50024 8.00018H12.5002C12.7764 8.00018 13.0002 8.22404 13.0002 8.50018C13.0002 8.77633 12.7764 9.00018 12.5002 9.00018H8.50024C8.2241 9.00018 8.00024 8.77633 8.00024 8.50018Z"
        fill="#3E7DC0"
      />
    </g>
    <g filter="url(#filter1_d_939_1064)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00024 11.5002C8.00024 11.224 8.2241 11.0002 8.50024 11.0002H12.5002C12.7764 11.0002 13.0002 11.224 13.0002 11.5002C13.0002 11.7763 12.7764 12.0002 12.5002 12.0002H8.50024C8.2241 12.0002 8.00024 11.7763 8.00024 11.5002Z"
        fill="#3E7DC0"
      />
    </g>
    <g filter="url(#filter2_d_939_1064)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0002 11.5002C14.0002 11.224 14.2241 11.0002 14.5002 11.0002H15.5002C15.7764 11.0002 16.0002 11.224 16.0002 11.5002C16.0002 11.7763 15.7764 12.0002 15.5002 12.0002H14.5002C14.2241 12.0002 14.0002 11.7763 14.0002 11.5002Z"
        fill="#3E7DC0"
      />
    </g>
    <rect x="1.5" y="14.0002" width="21" height="10" rx="2" fill="#3E7DC0" />
    <path
      d="M9.20703 20.2658C9.20703 20.62 9.11719 20.9351 8.9375 21.2111C8.75781 21.4846 8.4987 21.6981 8.16016 21.8517C7.82161 22.0028 7.42448 22.0783 6.96875 22.0783C6.58854 22.0783 6.26953 22.0523 6.01172 22.0002C5.75391 21.9455 5.48568 21.8517 5.20703 21.7189V20.3439C5.5013 20.495 5.80729 20.6135 6.125 20.6994C6.44271 20.7827 6.73438 20.8244 7 20.8244C7.22917 20.8244 7.39714 20.7853 7.50391 20.7072C7.61068 20.6265 7.66406 20.5236 7.66406 20.3986C7.66406 20.3205 7.64193 20.2528 7.59766 20.1955C7.55599 20.1356 7.48698 20.0757 7.39062 20.0158C7.29688 19.9559 7.04427 19.8335 6.63281 19.6486C6.26042 19.4793 5.98047 19.3153 5.79297 19.1564C5.60807 18.9976 5.47005 18.8153 5.37891 18.6096C5.29036 18.4038 5.24609 18.1603 5.24609 17.8791C5.24609 17.353 5.4375 16.9429 5.82031 16.6486C6.20312 16.3543 6.72917 16.2072 7.39844 16.2072C7.98958 16.2072 8.59245 16.3439 9.20703 16.6174L8.73438 17.8088C8.20052 17.564 7.73958 17.4416 7.35156 17.4416C7.15104 17.4416 7.00521 17.4767 6.91406 17.5471C6.82292 17.6174 6.77734 17.7046 6.77734 17.8088C6.77734 17.9208 6.83464 18.021 6.94922 18.1096C7.06641 18.1981 7.38151 18.3596 7.89453 18.5939C8.38672 18.8153 8.72786 19.0536 8.91797 19.3088C9.11068 19.5614 9.20703 19.8804 9.20703 20.2658Z"
      fill="#F8F8F8"
    />
    <path
      d="M13.8242 20.2658C13.8242 20.62 13.7344 20.9351 13.5547 21.2111C13.375 21.4846 13.1159 21.6981 12.7773 21.8517C12.4388 22.0028 12.0417 22.0783 11.5859 22.0783C11.2057 22.0783 10.8867 22.0523 10.6289 22.0002C10.3711 21.9455 10.1029 21.8517 9.82422 21.7189V20.3439C10.1185 20.495 10.4245 20.6135 10.7422 20.6994C11.0599 20.7827 11.3516 20.8244 11.6172 20.8244C11.8464 20.8244 12.0143 20.7853 12.1211 20.7072C12.2279 20.6265 12.2812 20.5236 12.2812 20.3986C12.2812 20.3205 12.2591 20.2528 12.2148 20.1955C12.1732 20.1356 12.1042 20.0757 12.0078 20.0158C11.9141 19.9559 11.6615 19.8335 11.25 19.6486C10.8776 19.4793 10.5977 19.3153 10.4102 19.1564C10.2253 18.9976 10.0872 18.8153 9.99609 18.6096C9.90755 18.4038 9.86328 18.1603 9.86328 17.8791C9.86328 17.353 10.0547 16.9429 10.4375 16.6486C10.8203 16.3543 11.3464 16.2072 12.0156 16.2072C12.6068 16.2072 13.2096 16.3439 13.8242 16.6174L13.3516 17.8088C12.8177 17.564 12.3568 17.4416 11.9688 17.4416C11.7682 17.4416 11.6224 17.4767 11.5312 17.5471C11.4401 17.6174 11.3945 17.7046 11.3945 17.8088C11.3945 17.9208 11.4518 18.021 11.5664 18.1096C11.6836 18.1981 11.9987 18.3596 12.5117 18.5939C13.0039 18.8153 13.3451 19.0536 13.5352 19.3088C13.7279 19.5614 13.8242 19.8804 13.8242 20.2658Z"
      fill="#F8F8F8"
    />
    <path
      d="M18.8516 18.1057C18.8516 18.7437 18.6628 19.2372 18.2852 19.5861C17.9102 19.9325 17.3763 20.1057 16.6836 20.1057H16.25V22.0002H14.707V16.2892H16.6836C17.4049 16.2892 17.9466 16.4468 18.3086 16.7619C18.6706 17.077 18.8516 17.5249 18.8516 18.1057ZM16.25 18.8478H16.5312C16.763 18.8478 16.9466 18.7827 17.082 18.6525C17.2201 18.5223 17.2891 18.3426 17.2891 18.1135C17.2891 17.728 17.0755 17.5353 16.6484 17.5353H16.25V18.8478Z"
      fill="#F8F8F8"
    />
    <defs>
      <filter
        id="filter0_d_939_1064"
        x="4.00024"
        y="8.00018"
        width="13"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1064"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1064"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_939_1064"
        x="4.00024"
        y="11.0002"
        width="13"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1064"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1064"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_939_1064"
        x="10.0002"
        y="11.0002"
        width="10"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1064"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1064"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_939_1064"
        x1="12.7428"
        y1="13.931"
        x2="12.7428"
        y2="6.39356"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#11AAE2" stop-opacity="0.25" />
      </linearGradient>
    </defs>
  </g>
</template>
